export default __webpack_public_path__ + "static/media/04_DAIF_Infra_03_01_loop.f6e93a9a.mp4";